module.exports = __webpack_public_path__ + "resources/images/screen7-4aa63ee15be5e4258304e8acbbce8ae5-cache.png";